import { create } from 'zustand';

export enum IFrameType {
  AiHsCodeLabeling = 'ai_hs_code_labeling',
  TariffAndRules = 'tariff_and_rules',
}

interface IState {
  visible?: boolean;
  iframe?: IFrameType;
}
interface IAction {
  dispatch: (payload: IState) => void;
}

export const usePopupRedirectStore = create<IState & IAction>((set) => ({
  visible: false,
  iframe: undefined,
  dispatch: (payload) => set((prev) => ({ ...prev, ...payload })),
}));
